<template>
    <Icon
        :name="name"
        :width="width"
        :height="height"
        :color="color"
        @click="$emit('click')"
    >
        <polyline class="a" points="0.75 0.75 0.75 23.25 23.25 23.25" />

        <line class="a" x1="15.937" y1="8.578" x2="20.43" y2="2.962" />

        <line class="a" x1="9.621" y1="7.359" x2="13.629" y2="9.14" />

        <line class="a" x1="0.75" y1="11.25" x2="6.964" y2="7.522" />

        <line class="a" x1="15.561" y1="16.521" x2="20.301" y2="13.888" />

        <line class="a" x1="8.25" y1="17.25" x2="12.75" y2="17.25" />

        <line class="a" x1="0.75" y1="20.25" x2="5.408" y2="17.921" />

        <circle class="a" cx="8.25" cy="6.75" r="1.5" />

        <circle class="a" cx="15" cy="9.75" r="1.5" />

        <circle class="a" cx="21.75" cy="2.25" r="1.5" />

        <circle class="a" cx="21.75" cy="13.5" r="1.5" />

        <circle class="a" cx="14.25" cy="17.25" r="1.5" />

        <circle class="a" cx="6.75" cy="17.25" r="1.5" />
    </Icon>
</template>

<script>
import Icon from '@/components/icons/Icon'

export default {
    name: 'LineChartIcon',
    components: {
        Icon,
    },
    props: {
        name: {
            type: String,
            default: '',
        },
        width: {
            type: [Number, String],
            default: 18,
        },
        height: {
            type: [Number, String],
            default: 18,
        },
        color: {
            type: String,
            default: '#000',
        },
    },
}
</script>

<style lang="scss" scoped>
.a {
    fill: none;
    stroke: currentColor;
    stroke-linecap: round;
    stroke-linejoin: round;
    stroke-width: 1.5px;
}
</style>
